export default "__VITE_ASSET__xEKs418v__"